const routesHome = [
  {
    path: '/',
    redirect: { name: 'Home' }
  },
  {
    path: '/home/:propertyId/device/:id',
    name: 'HomeDevice',
    component: () => import('@/views/home/DeviceView.vue'),
    meta: {
      title: 'Devices',
      backgroundTheme: 'brand-light'
    }
  },
  {
    path: '/add-property-units',
    name: 'AddPropertyOrUnits',
    component: {}
  }
]

export default routesHome
